const r = (o) => {
  if (o == null)
    return "hsl(216,24%, 96%)";
  let e = 0;
  if (o = o.trim().toLowerCase(), o.length == 0)
    return e.toString();
  for (let t = 0; t < o.length; t++)
    e = o.charCodeAt(t) + ((e << 5) - e), e = e & e;
  return "hsl(" + Math.abs(e) % 360 + ",35%, 60%)";
};
export {
  r as getColorFromString
};
